import { drawRoundedPolygon, fitToSize, sizeOptionsOrDefault } from './utils';
import { MultiPathShape } from './MultiPathShape';
const defaultOptions = {
    shapesOffsetRatio: 0.015,
};
/**
 * Represents a Sort shape, a flowchart element used to indicate sorting operations.
 * Extends MultiPathShape with two triangular shapes arranged vertically.
 */
export class Sort extends MultiPathShape {
    /**
     * Creates a new Sort instance.
     * @param options - Configuration options for the sort shape
     */
    constructor(options) {
        super({ ...defaultOptions, ...options });
    }
    /**
     * @hidden
     * Draws the sort shape path as two triangular shapes.
     */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const strokeWidth = this.options.stroke.width || 0;
        const cornerRadius = this.options.cornerRadius;
        const shapesOffset = this.options.shapesOffsetRatio * height;
        const halfHeight = height / 2;
        const firstShape = [
            { x: width / 2, y: 0 },
            { x: width, y: halfHeight - shapesOffset },
            { x: 0, y: halfHeight - shapesOffset }
        ];
        drawRoundedPolygon(drawingElement, firstShape, [cornerRadius / 3, cornerRadius, cornerRadius]);
        const secondShape = [
            { x: width / 2, y: height },
            { x: 0, y: halfHeight + shapesOffset },
            { x: width, y: halfHeight + shapesOffset }
        ];
        drawRoundedPolygon(drawingElement, secondShape, [cornerRadius / 3, cornerRadius, cornerRadius]);
        fitToSize(drawingElement, width, height, strokeWidth);
    }
}
